



























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BTablePag from "@/modules/program-monitor2/components/b-table-pag.vue";
import DFilterForm from '@/modules/development-program/filterForm.vue';
import DFormOfProgramModules from '@/modules/development-program/formOfProgramModules.vue';
import VueElementLoading from 'vue-element-loading';
import store from '@/services/store';
import axios from "axios";

@Component({
    name: "listOfPrograms",
    components: {
        'd-filter-form': DFilterForm,
        'b-table-pag': BTablePag,
        'd-form-program-modules': DFormOfProgramModules,
        'loading': VueElementLoading
    }
})
export default class DListOfPrograms extends Vue{
    @Prop({ default: null }) private currentYear!: number;
    @Prop({ default: null }) private selectedRegion!: any;
    @Prop({ default: null }) private filterPrgId!: number | null;
    @Prop({ default: null }) private regionsList!: any[];
    @Prop({ default: false }) hasEditAccess!: boolean;

    public modalVisible = false;
    private regionKato = '';
    private regionKatoPvldr = '';
    private programArr: any[] = [];
    private isArrayEmpty = true;
    private curYear = (new Date()).getFullYear();
    private selectedRow = 'selectedRow';
    private unselectedRow = 'unselectedRow';
    private programId = 0;
    public programObj = {};
    public prgDocNum = 0;
    public indicatorNum = 0;
    public eventNum = 0;
    public unitNum = 0;
    private programsList: any[] = [];
    private prgId: any;
    // private currentYear: any;
    private edit = false;
    private loading = false;
    private oblast: any;
    private currentProgramPassport = {
        programPassportId: '',
        programId: '',
        nameRu: '',
        nameKk: '',
        nameEn: '',
        startDate: '',
        endDate: '',
        expired: false,
        obl: ''
    };

    private async mounted() {
        this.loading=true;
        await this.fetchPrograms();
    }


    @Watch('currentYear')
    @Watch('selectedRegion')
    @Watch('filterPrgId')
    @Watch('regionsList')
    private async onFilterChange() {
        await this.fetchPrograms();
    }

    private async fetchPrograms() {
        this.loading = true;

        try {
            const year = this.currentYear;
            let regionCodes: string[] = [];

            if (this.selectedRegion?.code) {
                regionCodes = [this.selectedRegion.code];
            } else {
                regionCodes = this.regionsList.map(region => region.code);
            }

            const query = new URLSearchParams({
                year: String(year),
                codeKato: regionCodes.join(',')
            });

            if (this.filterPrgId) {
                query.append('programId', String(this.filterPrgId));
            }

            const response = await fetch(`/api/program-passport/get-passport-stats?${query}`);
            const data = await response.json();

            this.programsList = data.programs;
            this.prgDocNum = data.programs.length;
            this.indicatorNum = data.indicatorCount;
            this.eventNum = data.eventCount;
            this.unitNum = data.totalAmount;

        } catch (err) {
            this.makeToast('danger', 'Ошибка загрузки программ', err.toString());
        } finally {
            this.loading = false;
        }
    }

    private usrId() {
        if (store.state.user.sub === undefined) { return null; }
        return store.state.user.sub;
    }

    private closePassport(close: any){
        this.edit = close;
    }

    private padLeadingZeros(num: string, size: number) {    // -------добавление нулей после значения в зависимости от размера значения
        let s = num;
        while (s.length < size) { s = s + '0'; }
        return s;
    }

    private showProgramListForm(show: any){
        if (show !== null){
            this.getDataFromFilter(show);
        }
    }

    private getDataFromFilter(show: boolean){
        if (show){
            this.modalVisible = true;
            this.loadPrograms();
        }
    }

    private async deleteRow(prgItem: any, prgIndex: any) {
        if (!this.hasEditAccess) {
            this.makeToast('warning', 'Доступ запрещен', 'У вас нет прав для удаления программ');
            return;
        }

        try {
            const headers = { 'Content-Type': 'application/json' };
            const result = await axios.post(`/api/program-passport/del-program/${prgItem.id}/${prgItem.program.id}/${this.currentYear}`, {}, { headers });

            if (result.status === 200) {
                if (result.data === true) {
                    await this.fetchPrograms(); // Обновляем список
                    this.makeToast('success', 'Удаление', 'Данные успешно удалены');
                } else {
                    this.makeToast('danger', 'Удаление', 'Удаление программы невозможно, так как имеются Целевые индикаторы. Пожалуйста сначала удалите целевые индикаторы');
                }
            } else {
                this.makeToast('danger', 'Удаление', `Ошибка ${result.status} ${result.statusText}`);
            }
        } catch (error) {
            console.error(error);
            this.makeToast('danger', 'Ошибка', 'Произошла ошибка при удалении');
        }
    }

    private chooseProgram(elItem: any, elItemIndex: any){
        if (elItemIndex!=null){
            this.programId = elItem.id;
            this.programObj = elItem;
        }
    }

    private async listOfProgramsInPassport(currentYear: any, prgId: any) {
        this.prgId = prgId;
        this.currentYear = currentYear;
        let response: any = null;
        try {
            // console.log('currentYear: ' + currentYear + ' prgId: ' + prgId);
            response = await fetch('/api/program-passport/get-passport?year=' + currentYear + '&prgId=' + prgId);
            response = await response.json();
            this.programsList = response;
            let countProgIds = 0;
            for (const res of response){
                if (res.id!==null){
                    countProgIds += 1;
                }
            }
            this.prgDocNum = countProgIds;
            this.loading=false;
            // console.log('this.programsList: ' + JSON.stringify(this.programsList));
        } catch (error) {
            this.makeToast('danger', 'Ошибка загрузки Паспорта программ', error.toString());
        }
    }

    private moveToPassport(prgItem: any) {
        this.edit = true;
        this.currentProgramPassport.programPassportId = prgItem.id;
        this.currentProgramPassport.programId = prgItem.program.id;
        this.currentProgramPassport.nameRu = prgItem.program.name_ru;
        this.currentProgramPassport.nameKk = prgItem.program.name_kz;
        this.currentProgramPassport.nameEn = prgItem.program.name_en;
        this.currentProgramPassport.startDate = prgItem.startDate;
        this.currentProgramPassport.endDate = prgItem.endDate;
        this.currentProgramPassport.expired = (new Date(prgItem.endDate).getFullYear() < this.curYear);
        this.currentProgramPassport.obl = prgItem.program.codeKato;
    }

    private reloadList() {
        const listComponent = this.$refs.listOfPrograms as any;
        if (listComponent?.reloadPrograms) {
            listComponent.reloadPrograms();
        }
    }

    private async loadPrograms() {
        this.programArr = [];
        const result = [];

        if (!this.curYear || !this.selectedRegion || !this.selectedRegion.code) {
            this.isArrayEmpty = true;
            return;
        }

        const regionCode = this.padLeadingZeros(this.selectedRegion.code, 9);

        const selectedProgramIds = this.programsList.map(p => p.program?.id).filter(Boolean);
        this.$emit('existingProgramsUpdated', this.programsList.map(p => p.program_id));

        try {
            const queryParams = new URLSearchParams({
                year: String(this.curYear),
                codeKato: regionCode
            });

            // Add exclusion list if needed
            if (selectedProgramIds.length > 0) {
                queryParams.append('excludeIds', selectedProgramIds.join(','));
            }

            const response = await fetch(`/api/program-passport/available-programs?${queryParams.toString()}`);
            const data = await response.json();

            if (data.length > 0) {
                for (const el of data) {
                    result.push(this.setNameLangs(el, null));
                }
                this.isArrayEmpty = false;
            }

            this.programArr = result;
        } catch (error) {
            this.makeToast('danger', 'Ошибка загрузки Программ', error.toString());
        }
    }

    // ----Создание объектов на основе переданных данных из справочников----//
    private setNameLangs(obj: any | null, codeName: any | null) {
        let txt = '';
        txt = obj.name_ru;
        // console.log('txt: ' + txt)
        if (txt === undefined) { txt = obj.name_ru; }
        if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
            txt = obj[codeName] + ' - ' + txt;
            // console.log('txt: ' + txt);
        }
        const el = Object.assign({}, obj);
        el.name = txt;
        // console.log('el: ' + JSON.stringify(el));
        return el;
    }

    // ------Метод для отображения сообщения с ошибками----//
    private makeToast(variant: any, title: string, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            autoHideDelay: 5000,
            variant: variant,
            appendToast: true
        });
    } // сообщение с ошибкой
}
